import { Navigate, Route, Routes } from "react-router";

import { AppShell } from "@/components/AppShell";
import { ImageArenaPage } from "@/features/image/ImageArenaPage";
import { TextArenaPage } from "@/features/text/TextArenaPage";

export const App = () => (
  <AppShell>
    <Routes>
      <Route path="/" element={<TextArenaPage />} />
      <Route path="/images" element={<ImageArenaPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </AppShell>
);
